import { environment } from "src/environments/environment";

import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class AppConfigService {
  loadAppConfig(): Promise<void> {
    const timestamp = new Date().getTime();
    const readJson = (path: string): Promise<Record<string, unknown> | null> =>
      fetch(`${path}?t=${timestamp}`)
        .then((res) => (res.ok ? res.json() : null))
        .catch(() => null);

    // Sans fichier lisible, l'app démarre avec l'apiUrl du build plutôt que sur une page blanche.
    return readJson("/assets/dynamic-env.local.json")
      .then((local) => local ?? readJson("/assets/dynamic-env.json"))
      .then((config) => config ?? readJson("/assets/dynamic-env.json"))
      .then((config) => {
        if (config) {
          Object.assign(environment, config);
        }
      });
  }
}
